export default {
  pages: {
    key: "title",
    data: [
      { title: "Home", url: "/", icon: "HomeIcon", is_bookmarked: false },
      { title: "Indicators", url: "/indicators", icon: "FileIcon", is_bookmarked: false },
    ],
  },
};
